import React from 'react';

export const BrowserHistoryContext = React.createContext();

BrowserHistoryContext.displayName = 'BrowserHistoryContext';

export default BrowserHistoryContext;
